import { TOGGLE_EXIT_MODAL } from './actions';

export default function reducer(state = false, action = {}) {
  if (action.type === TOGGLE_EXIT_MODAL) {
    return !state;
  }
  return state;
}
